export const SITE_URL = 'https://bluealps.org';
export const ORGANIZATION_ID = `${SITE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export interface RouteSeo {
  path: string;
  seo: Record<SupportedSeoLanguage, RouteSeoContent>;
  type?: 'WebPage' | 'AboutPage' | 'ContactPage' | 'CollectionPage';
  noindex?: boolean;
}

export type SupportedSeoLanguage = 'pt' | 'en' | 'de';

export interface RouteSeoContent {
  title: string;
  description: string;
  breadcrumb: string;
}

export const ROUTE_SEO: RouteSeo[] = [
  {
    path: '/',
    seo: {
      pt: {
        title: 'BlueAlps | Tecnologia que conecta inovação e impacto',
        description:
          'A BlueAlps desenvolve soluções sustentáveis de tecnologia, SEO, PIM, UX e cibersegurança para inovação e impacto.',
        breadcrumb: 'Início',
      },
      en: {
        title: 'BlueAlps | Technology that connects innovation and impact',
        description:
          'BlueAlps builds sustainable technology, SEO, PIM, UX and cybersecurity solutions to reduce inequalities and generate positive impact.',
        breadcrumb: 'Home',
      },
      de: {
        title: 'BlueAlps | Technologie, die Innovation und Wirkung verbindet',
        description:
          'BlueAlps entwickelt nachhaltige Lösungen für Technologie, SEO, PIM, UX und Cybersicherheit, die Innovation und Wirkung verbindet',
        breadcrumb: 'Startseite',
      },
    },
    type: 'WebPage',
  },
  {
    path: '/services',
    seo: {
      pt: {
        title: 'Serviços BlueAlps | SEO, PIM, WordPress, UX e Cibersegurança',
        description:
          'Conheça os serviços da BlueAlps em SEO técnico, PIM, WordPress, UX, cibersegurança e auditorias com práticas de tecnologia sustentável.',
        breadcrumb: 'Serviços',
      },
      en: {
        title: 'BlueAlps Services | SEO, PIM, WordPress, UX and Cybersecurity',
        description:
          'Explore BlueAlps services for technical SEO, PIM, WordPress, UX, cybersecurity and audits, with sustainable technology practices.',
        breadcrumb: 'Services',
      },
      de: {
        title:
          'BlueAlps Dienstleistungen | SEO, PIM, WordPress, UX und Cybersicherheit',
        description:
          'Entdecken Sie BlueAlps Dienstleistungen für technisches SEO, PIM, WordPress, UX, Cybersicherheit und Audits mit nachhaltigen Technologiepraktiken.',
        breadcrumb: 'Dienstleistungen',
      },
    },
    type: 'CollectionPage',
  },
  {
    path: '/about',
    seo: {
      pt: {
        title: 'Sobre a BlueAlps | Empresa suíço-brasileira de tecnologia',
        description:
          'Conheça a BlueAlps, empresa suíço-brasileira especializada em software personalizado, inteligência artificial, automação e transformação digital.',
        breadcrumb: 'Sobre nós',
      },
      en: {
        title: 'About BlueAlps | Swiss-Brazilian Technology Company',
        description:
          'Learn about BlueAlps, a Swiss-Brazilian technology company specializing in custom software, artificial intelligence, automation and digital transformation.',
        breadcrumb: 'About us',
      },
      de: {
        title:
          'Über BlueAlps | Schweizerisch-brasilianisches Technologieunternehmen',
        description:
          'Erfahren Sie mehr über BlueAlps, ein schweizerisch-brasilianisches Technologieunternehmen für individuelle Software, künstliche Intelligenz, Automatisierung und digitale Transformation.',
        breadcrumb: 'Über uns',
      },
    },
    type: 'AboutPage',
  },
  {
    path: '/impact',
    seo: {
      pt: {
        title: 'Impacto BlueAlps | Tecnologia para mudança positiva',
        description:
          'Veja como a BlueAlps conecta Suíça e Brasil por meio de tecnologia, sustentabilidade e projetos com impacto social positivo.',
        breadcrumb: 'Impacto',
      },
      en: {
        title: 'BlueAlps Impact | Technology for Positive Change',
        description:
          'Learn how BlueAlps connects Switzerland and Brazil through technology, sustainability and projects with positive social impact.',
        breadcrumb: 'Impact',
      },
      de: {
        title: 'BlueAlps Wirkung | Technologie für positive Veränderung',
        description:
          'Erfahren Sie, wie BlueAlps die Schweiz und Brasilien durch Technologie, Nachhaltigkeit und Projekte mit positivem sozialem Impact verbindet.',
        breadcrumb: 'Wirkung',
      },
    },
    type: 'AboutPage',
  },
  {
    path: '/projects',
    seo: {
      pt: {
        title: 'Projetos BlueAlps | Trabalhos digitais e cases',
        description:
          'Veja projetos e trabalhos digitais da BlueAlps em SEO, web, UX e iniciativas de tecnologia sustentável.',
        breadcrumb: 'Projetos',
      },
      en: {
        title: 'BlueAlps Projects | Digital Work and Client Cases',
        description:
          'See BlueAlps projects and digital work across SEO, web, UX and sustainable technology initiatives.',
        breadcrumb: 'Projects',
      },
      de: {
        title: 'BlueAlps Projekte | Digitale Arbeiten und Kundenprojekte',
        description:
          'Sehen Sie BlueAlps Projekte und digitale Arbeiten in SEO, Web, UX und nachhaltigen Technologieinitiativen.',
        breadcrumb: 'Projekte',
      },
    },
    type: 'CollectionPage',
  },
  {
    path: '/contact',
    seo: {
      pt: {
        title: 'Contato BlueAlps | WhatsApp e email',
        description:
          'Entre em contato com a BlueAlps por WhatsApp ou email para falar sobre tecnologia sustentável, SEO, PIM, WordPress, UX e cibersegurança.',
        breadcrumb: 'Contato',
      },
      en: {
        title: 'Contact BlueAlps | WhatsApp and Email',
        description:
          'Contact BlueAlps by WhatsApp or email to discuss sustainable technology, SEO, PIM, WordPress, UX and cybersecurity work.',
        breadcrumb: 'Contact',
      },
      de: {
        title: 'Kontakt BlueAlps | WhatsApp und E-Mail',
        description:
          'Kontaktieren Sie BlueAlps per WhatsApp oder E-Mail, um über Technologie,, SEO, PIM, WordPress, UX und Cybersicherheit zu sprechen.',
        breadcrumb: 'Kontakt',
      },
    },
    type: 'ContactPage',
  },
  {
    path: '/links',
    seo: {
      pt: {
        title: 'BlueAlps | Links',
        description: 'Links oficiais da BlueAlps para Instagram.',
        breadcrumb: 'Instagram',
      },
      en: {
        title: 'BlueAlps | Links',
        description: 'Official BlueAlps links for Instagram.',
        breadcrumb: 'Instagram',
      },
      de: {
        title: 'BlueAlps | Links',
        description: 'Offizielle BlueAlps Links fuer Instagram.',
        breadcrumb: 'Instagram',
      },
    },
    type: 'ContactPage',
    noindex: true,
  },
  {
    path: '/imprint',
    seo: {
      pt: {
        title: 'Imprint | BlueAlps',
        description: 'Informações legais e dados institucionais da BlueAlps.',
        breadcrumb: 'Imprint',
      },
      en: {
        title: 'Imprint | BlueAlps',
        description: 'Legal imprint and company information for BlueAlps.',
        breadcrumb: 'Imprint',
      },
      de: {
        title: 'Impressum | BlueAlps',
        description:
          'Rechtliche Angaben und Unternehmensinformationen von BlueAlps.',
        breadcrumb: 'Impressum',
      },
    },
    type: 'WebPage',
  },
  {
    path: '/privacy-policy',
    seo: {
      pt: {
        title: 'Política de Privacidade | BlueAlps',
        description:
          'Política de privacidade e informações sobre proteção de dados da BlueAlps.',
        breadcrumb: 'Política de Privacidade',
      },
      en: {
        title: 'Privacy Policy | BlueAlps',
        description: 'BlueAlps privacy policy and data protection information.',
        breadcrumb: 'Privacy Policy',
      },
      de: {
        title: 'Datenschutzerklärung | BlueAlps',
        description:
          'BlueAlps Datenschutzerklärung und Informationen zum Datenschutz.',
        breadcrumb: 'Datenschutzerklärung',
      },
    },
    type: 'WebPage',
  },
  {
    path: '/cookie-policy',
    seo: {
      pt: {
        title: 'Política de Cookies | BlueAlps',
        description:
          'Política de cookies da BlueAlps e informações sobre tecnologias de rastreamento.',
        breadcrumb: 'Política de Cookies',
      },
      en: {
        title: 'Cookie Policy | BlueAlps',
        description:
          'BlueAlps cookie policy and tracking technology information.',
        breadcrumb: 'Cookie Policy',
      },
      de: {
        title: 'Cookie-Richtlinie | BlueAlps',
        description:
          'BlueAlps Cookie-Richtlinie und Informationen zu Tracking-Technologien.',
        breadcrumb: 'Cookie-Richtlinie',
      },
    },
    type: 'WebPage',
  },
];

export const NOT_FOUND_SEO: RouteSeo = {
  path: '*',
  seo: {
    pt: {
      title: 'Página não encontrada | BlueAlps',
      description: 'A página solicitada da BlueAlps não foi encontrada.',
      breadcrumb: 'Página não encontrada',
    },
    en: {
      title: 'Page Not Found | BlueAlps',
      description: 'The requested BlueAlps page could not be found.',
      breadcrumb: 'Not Found',
    },
    de: {
      title: 'Seite nicht gefunden | BlueAlps',
      description: 'Die angeforderte BlueAlps Seite wurde nicht gefunden.',
      breadcrumb: 'Seite nicht gefunden',
    },
  },
  type: 'WebPage',
  noindex: true,
};

export const SERVICE_ITEMS = [
  'Technical SEO',
  'PIM',
  'WordPress',
  'UX',
  'Cybersecurity',
  'Audit',
];

export const PROJECT_ITEMS = [
  'Divina',
  'Farol SEO',
  'Gallery Gleis 4',
  'Mueller Handarbeiten',
  'Sport 1001',
  'Vermando',
];

export const normalizePathname = (pathname: string) => {
  if (!pathname || pathname === '/') {
    return '/';
  }

  return pathname.replace(/\/+$/, '');
};

export const getRouteSeo = (pathname: string) => {
  const normalizedPath = normalizePathname(pathname);

  if (normalizedPath.startsWith('/services/')) {
    return (
      ROUTE_SEO.find((route) => route.path === '/services') ?? NOT_FOUND_SEO
    );
  }

  return (
    ROUTE_SEO.find((route) => route.path === normalizedPath) ?? NOT_FOUND_SEO
  );
};

export const normalizeSeoLanguage = (
  language?: string,
): SupportedSeoLanguage => {
  const baseLanguage = language?.toLowerCase().split('-')[0];

  if (baseLanguage === 'en' || baseLanguage === 'de') {
    return baseLanguage;
  }

  return 'pt';
};

export const getLocalizedRouteSeo = (pathname: string, language?: string) => {
  const routeSeo = getRouteSeo(pathname);
  const seoLanguage = normalizeSeoLanguage(language);

  return {
    ...routeSeo,
    ...routeSeo.seo[seoLanguage],
    language: seoLanguage,
  };
};

export const getCanonicalUrl = (pathname: string) => {
  const normalizedPath = normalizePathname(pathname);
  return `${SITE_URL}${normalizedPath === '/' ? '/' : normalizedPath}`;
};
